/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'svg-folder-files': {
    width: 16,
    height: 16,
    viewBox: '0 0 58.001 58.001',
    data: '<path pid="0" d="M54.001 22.5v-10H52v-4H25l-2-4H2.732A2.736 2.736 0 0 0 0 7.233V52.5l.001-.002v.002c0 .734-.047 1 .565 1h44.759c1.156 0 2.174-.779 2.45-1.813L58.001 23.5v-1h-4zM50 10.5v2H7v2H5v-4h45zM8.001 15.914V18.5H5.415l2.586-2.586zm44 5.586h-8v-3a1 1 0 1 0-2 0v3h-5v-3a1 1 0 1 0-2 0v3h-5v-3a1 1 0 1 0-2 0v3h-5v-3a1 1 0 1 0-2 0v3h-5v-3a1 1 0 1 0-2 0v3h-2.269c-1.157 0-2.175.779-2.45 1.813l-5.281 14.48V20.5h6v-6h42v7z"/>'
  }
})
